<template>
  <div class="extended-filter-block">
    <h2>Дневник эмоций</h2>
  </div>
  <div v-if="(permittedSubscriptions.length && availableSubscriptionTools.includes('diary') && hasDiaryAccess) || getRight('superadmin')" class="card">
    <div class="card-body">
      <div class="description">
        <p>
          ЗДЕСЬ ВЫ МОЖЕТЕ ОТМЕЧАТЬ СВОИ ЭМОЦИИ И ПРИЧИНЫ ИХ ПОЯВЛЕНИЯ, А ЗАТЕМ -
          СМОТРЕТЬ СТАТИСТИКУ, ЧТОБЫ АНАЛИЗИРОВАТЬ И РАСТИ В ОСОЗНАННОСТИ И
          БИЗНЕСЕ.
        </p>
      </div>
      <div class="info_wrapper">
        <div class="info_block_wrapper">
          <img class="info_icon" alt="Иконка" src="@/assets/images/Certificate.svg">
          <div class="info_text_wrapper">
            <p>
              Заполняя дневник эмоций, вы уже развиваете свой эмоциональный интеллект &ndash; вы
              распознаете свои эмоции, анализируете их причины, а может, даже задумываетесь над тем,
              полезна ли сейчас данная эмоция и нужно ли ею управлять <span class="winking_face"></span>
            </p>
          </div>
        </div>
        <div class="emotion_library_wrapper">
          <div>
            <p>
              Здесь вы можете более подробно узнать про каждую из 27 эмоций.
            </p>
          </div>
          <div>
            <button class="btn btn-accent" @click="() => { router.push('/library/list')}">Библиотека эмоций</button>
          </div>
        </div>
        <div class="info_block_wrapper">
          <div class="info_text_wrapper">
            <p>
              Это позволяет вам заложить фундамент для ежедневного развития эмоционального
              интеллекта и сформировать привычку качественно распознавать эмоции.
            </p>
          </div>
          <img class="info_icon" alt="Иконка" src="@/assets/images/Grow.svg">
        </div>
      </div>

      <div v-if="settings && settings.intervals || firstUsage " class="records_form_wrapper">
        <div v-if="!diaryAvailable && nextInterval && !forceFill" class="records_control_wrapper">
          <div class="next_available_interval">
            <p>Следующий интервал для записи в Дневник начнется в {{ nextInterval }}.</p>
            <div class="record_now_text_wrapper">
              <p>Хотите сделать запись сейчас?</p>
              <div class="record_now_line_wrapper">
                <div class="arrow_line"></div>
                <div class="arrow_big"></div>
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-accent" @click="() => forceFill = true">Сделать запись</button>
          </div>
        </div>

        <div v-if="diaryAvailable || firstUsage || forceFill">
          <diary-record-form
              :availableInterval="allowedPeriod"
              :firstUsage="firstUsage"
              :forceFill="forceFill"
              @recordCreated="(id) => {
                if (firstUsage) {
                  setDiaryAfterFirstRecord();
                }
                lastCreatedRecord = id;
              }"
          />
        </div>
      </div>
      <div v-if="lastCreatedRecord" class="record_saved_wrapper">
        <p class="record_saved_header">Запись успешно сохранена!</p>

        <p>Фиксируйте эмоции каждый день: пару минут регулярного внимания к себе, и эта
          привычка станет естественной частью вашей жизни. Для удобства настройте инструмент
          под себя: укажите удобные интервалы для заметок. Так же, чтобы не пропустить
          указанный интервал, вы можете настроить напоминания в чат боте.</p>
      </div>

      <div class="setting_block_wrapper">
        <div v-if="showSettingInstruction" class="settings_instruction">
          <p class="settings_instruction_header">Инструкция:</p>
          <ul class="settings_steps_list">
            <li>
              Выберите временной интервал &ndash; насколько часто вы бы хотели отмечать свои эмоции и в какое время?
            </li>
            <li>
              Когда пришло время указать испытываемую эмоцию, нажмите на “Записать эмоцию” и выберите эмоцию из списка.
            </li>
            <li>
              Укажите интенсивность испытываемой
              эмоции.
            </li>
            <li>
              Выберите причину данной эмоции.
            </li>
            <li>
              Нажмите “Сохранить”.
            </li>
          </ul>
          <p class="settings_instruction_result">
            Все, запись сделана!
          </p>
        </div>

        <div v-if="showSettingInstruction"  class="arrow_wrapper">
          <div class="additional_arrow_wrapper">
            <div class="arrow_line"></div>
            <div class="arrow"></div>
          </div>
        </div>

        <div class="settings">
          <div class="instruction_buttons_wrapper">
            <button v-if="showSettingInstruction"
                    @click="showSettings = !showSettings" class="btn settings_btn"
                    :class="{ active: showSettings }">
              {{ showSettings ? 'Показать интервалы' : 'Выбрать интервал' }}
            </button>

            <button
                    class="btn show_settings_instruction_btn"
                    :class="{ 'button_active': showSettingInstruction }"
                    @click="() => {
                          showSettingInstruction = !showSettingInstruction;
                          setSettingState('diarySetting', showSettingInstruction);
              }"
            >
              {{ showSettingInstruction ? 'Скрыть' : 'Выбрать интервал' }}
            </button>
          </div>

          <div v-if="!showSettings && settings && settings.intervals && showSettingInstruction">
            <p>Вы отметили, что хотели бы использовать инструмент &laquo;Дневник эмоций&raquo;
              <strong>{{ settings.periodicity }}</strong> {{ [2, 3, 4].includes(settings.periodicity) ? 'раза' : 'раз' }}
              в день в следующие временные промежутки:
              <span v-for="(interval, index) in settings.intervals" :key="index">
                  <strong>{{ interval }}</strong>{{ settings.intervals.length === index + 1 ? '' : ', ' }}
              </span>.
            </p>
            <p v-if="!diaryAvailable" class="change_intervals_text">Хотите поменять или дополнить временные интервалы?</p>
          </div>
          <div v-else-if="!showSettings && showSettingInstruction">
            <p>Интервалы не выбраны</p>
          </div>
          <div v-if="showSettings && showSettingInstruction">
            <diary-settings
                @settingsUpdated="() => {
              checkDate()
              showSettings = false;
            }"
            />
          </div>
        </div>
      </div>

      <div class="telegram_block">
        <div class="telegram_setting_button">
          <button class="btn btn-accent telegram_btn" :class="[{ 'button_active': showTelegramBlock}]" @click="() => {
            showTelegramBlock = !showTelegramBlock;
            setSettingState('telegramSetting', showTelegramBlock);
          }">
            {{ showTelegramBlock ? 'Скрыть' : 'Telegram-bot'}}
          </button>
        </div>
        <div v-if="showTelegramBlock" class="telegram_wrapper">
            <div class="bot_description">
              <p>Подписывайтесь на бота в телеграм, который будет помогать вести дневник эмоций</p>
            </div>
            <div class="telegram_button_wrapper">
              <a class="telegram_button" href="https://t.me/EmoJournal_W2Wbot">
                Подписаться на Telegram-bot
              </a>
            </div>
        </div>
        <div v-if="showTelegramBlock" class="telegram_instruction_wrapper">
            <p class="telegram_instruction_header">
              Как настроить Telegram-bot?
            </p>
            <p>
              Отмечать эмоции можно и в боте в телеграм, который синхронизирован с личным кабинетом.
            </p>
            <ul class="telegram_instruction_list">
              <li>
                Для этого открыть бота и следовать инструкции по настройке.
              </li>
              <li>
                Далее настраиваем время для напоминаний.
              </li>
              <li>
                Как только подойдет время, бот напомнит и предложит сразу в нем сделать запись.
              </li>
              <li>
                Статистику можно посмотреть в личном кабинете.
              </li>
              <li>
                Личный кабинет и бот синхронизированы, отмеченные в боте результаты также попадают в личный кабинет и сохраняются там.
              </li>
            </ul>
        </div>
      </div>

      <div>
        <div v-if="diaryRecords && diaryRecords.length" class="analytics_wrapper">
          <div class="analytics_text">
            <p>
              Вы можете посмотреть аналитику ваших эмоциональных состояний и причин ваших эмоций, нажав на кнопку "посмотреть статистику записей".
            </p>
          </div>
          <div class="analytics_button_wrapper">
            <button class="btn btn-accent" @click="() => {
                router.push('/diary/Analytics')
              }">
              Посмотреть статистику записей
            </button>
          </div>
        </div>
      </div>
      <div v-if="settings && settings.intervals">
        <div class="records" :key="lastCreatedRecord">
          <diary-records/>
        </div>
      </div>
      <div class="diary_description">
        <h2 class="header_green diary_additional_header">
          Зачем вести дневник эмоций
        </h2>
        <div class="diary_explanation_wrapper">
          <p>
            Как часто вы обращаете внимание на свои эмоции?
          </p>
          <p>
            Эмоции помогают нам налаживать связи, выполняя социализирующую функцию, помогают избежать опасности и многое другое.
          </p>
          <p>
            Эмоции – это данные, и мы можем использовать эти данные в своей ежедневной жизни и деятельности для повышения своей эффективности и достижения результатов.
          </p>
          <p>
            В жизни нет ни одной ситуации, в которой не задействована эмоциональная сфера человека. Хорошая новость в том, что вы можете развить свой эмоциональный интеллект, немного потренировавшись.
          </p>
          <p>
            Эмоциональный интеллект определяется как способность распознавать эмоции, использовать их в решении задач, понимать их причины и управлять ими, а также успешно взаимодействовать и ориентироваться в эмоциях других.
          </p>
          <p>
            Высокоразвитый эмоциональный интеллект помогает нам строить более крепкие отношения, преуспевать в школе и на работе, а также достигать своих карьерных и личных целей.
          </p>
          <p>
            Чтобы качественно применять эмоции в жизни и бизнесе, важно научиться их грамотно распознавать.
          </p>
          <p>
            Мы создали специальный дневник, который поможет вам осознавать свои эмоции, понимать причины их возникновения, определять преобладающую у вас в течение дня, месяца, а может быть даже и года эмоцию, понимать, насколько эффективно вы используете свои эмоции в ежедневной жизни и учиться использовать информацию, содержащуюся в эмоциях для достижения своих целей.
          </p>
        </div>
        <div class="additional_library_link_wrapper">
          <p>
            Сделайте СВОИ эмоции СВОИМ управляемым ресурсом.
          </p>
          <p>
            Открывайте, осваивайте и развивайте этот ресурс с нашим дневником.
          </p>
          <div class="additional_library_button_wrapper">
            <button class="btn btn-accent" @click="() => { router.push('/library/list')}">Узнать больше об эмоциях</button>
          </div>
        </div>
      </div>
      <div class="form-preloader" v-if="!isLoaded">
        <div>
          <mini-preloader/>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="card subscription-required">
    Чтобы использовать этот инструмент, необходимо оформить подписку. Пожалуйста, сделайте это для получения доступа.
  </div>
</template>

<script>
import CustomInput from "@/components/Forms/Fields/CustomInput.vue";
import {onBeforeMount, reactive, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import CustomSelect from "@/components/Forms/Fields/CustomSelect.vue";
import DiarySettings from "@/views/EmotionDiary/DiarySettings.vue";
import Preloader from "@/App.vue";
import MiniPreloader from "@/components/Technical/MiniPreloader.vue";
import DiaryRecords from "@/views/EmotionDiary/DiaryRecords.vue";
import DiaryRecordForm from "@/views/EmotionDiary/DiaryRecordForm.vue";
import {useRouter} from "vue-router";
import useCheckRights from "@/mixins/useCheckRights";

export default {
  name: "EmotionDiary.vue",
  components: {DiaryRecordForm, DiaryRecords, MiniPreloader, Preloader, DiarySettings, CustomSelect, CustomInput},
  setup() {
    const {getRight} = useCheckRights();
    const user = computed(() => store.state.profile.profile);
    const router = useRouter();
    const store = useStore();
    const settings = computed(() => store.state.diary.diarySettings);
    const diaryRecords = computed(() => store.state.diary.diaryRecords);
    const isLoaded = ref(false);
    const showSettings = ref(false);
    const showAnalytics = ref(false);
    const lastCreatedRecord = ref();
    const nextInterval = ref('');
    const diaryAvailable = ref(false);
    const allowedPeriod = ref('');
    const forceFill = ref(false);

    const showTelegramBlock = ref(true);
    const showSettingInstruction = ref(true);

    const permittedSubscriptions = computed(() => store.state.subscription.permittedSubscriptions);

    const setSettingState = (flag, value) => {
        localStorage.setItem(flag, JSON.stringify(value));
    }

    const checkDate = () => {
      const now = new Date();
      if (diaryAvailable.value && settings.value.intervals.some((el) => el === allowedPeriod.value)) {
        let periods = allowedPeriod.value.split('-');

        let endPeriod = new Date();
        let endPeriodHours = periods[1].split(':')[0];
        let endPeriodMinutes = periods[1].split(':')[1];
        endPeriod.setHours(endPeriodHours, endPeriodMinutes, 59);

        if (now > endPeriod) {
          diaryAvailable.value = false;
          let index = settings.value.intervals.indexOf(allowedPeriod.value);
          if (index + 1 < settings.value.intervals.length) {
            nextInterval.value = settings.value.intervals[index + 1].split('-')[0];
          } else {
            nextInterval.value = settings.value.intervals[0].split('-')[0];
          }
        }
      } else {
        diaryAvailable.value = false;
        let closestInterval = null;
        settings.value.intervals.map((interval) => {
          let periods = interval.split('-');

          let startPeriod = new Date();
          let startPeriodHours = periods[0].split(':')[0];
          let startPeriodMinutes = periods[0].split(':')[1];
          startPeriod.setHours(startPeriodHours, startPeriodMinutes, 0);

          let endPeriod = new Date();
          let endPeriodHours = periods[1].split(':')[0];
          let endPeriodMinutes = periods[1].split(':')[1];
          endPeriod.setHours(endPeriodHours, endPeriodMinutes, 59);

          if (now >= startPeriod && now <= endPeriod) {
            diaryAvailable.value = true
            allowedPeriod.value = interval;
          } else if (now < startPeriod) {
            if (!closestInterval) {
              closestInterval = periods[0];
            }
          }
        });

        nextInterval.value = closestInterval ? closestInterval : settings.value.intervals[0].split('-')[0];
      }
    }

    const firstUsage = ref(false);

    const setDiaryAfterFirstRecord = () => {
      store.dispatch('diary/getDiarySettings').then(() => {
        checkDate();
      });
      showSettings.value = false;
    }

    const checkInstrumentAccess = () => {
      permittedSubscriptions.value.map((subscription) => {
        if (subscription.instruments.length) {
          subscription.instruments.forEach((instrument) => {
            if (!availableSubscriptionTools.value.includes(instrument)) {
              availableSubscriptionTools.value.push(instrument);
            }
          });
        }
        if (subscription.staff_instruments_access && !hasDiaryAccess.value) {
          hasDiaryAccess.value = subscription.staff_instruments_access.diary.find((staffId) => staffId === user.value.id)
        }
      })

      if (getRight('private_person') && !hasDiaryAccess.value) {
        hasDiaryAccess.value = availableSubscriptionTools.value.includes('diary');
      }
    }

    onBeforeMount(() => {
      if (!permittedSubscriptions.value || !permittedSubscriptions.value.length) {
        if (getRight('subscription') && user.value?.id) {
          store.dispatch('subscription/getPermittedSubscriptions', user.value?.company?.id ?? null);
        }
      } else {
        checkInstrumentAccess();
      }

      store.dispatch("diary/getEmotionList");
      store.dispatch('diary/getRecords');

      store.dispatch('diary/getDiarySettings').then(() => {
        isLoaded.value = true;
        if (!settings.value.intervals) {
          firstUsage.value = true;
          showSettings.value = true;
        } else {
          checkDate();
          setInterval(checkDate, 30000);
        }
      });

      showTelegramBlock.value = localStorage.getItem('telegramSetting') ? JSON.parse(localStorage.getItem('telegramSetting')) : 1;
      showSettingInstruction.value = localStorage.getItem('diarySetting') ? JSON.parse(localStorage.getItem('diarySetting')) : 1;
    });

    const availableSubscriptionTools = ref([]);
    const hasDiaryAccess = ref(false);

    watch(() => permittedSubscriptions.value, () => {
        checkInstrumentAccess();
    });

    return {
      isLoaded,
      settings,
      showAnalytics,
      showSettings,
      diaryRecords,
      lastCreatedRecord,
      diaryAvailable,
      allowedPeriod,
      nextInterval,
      router,
      checkDate,
      getRight,
      permittedSubscriptions,
      firstUsage,
      setDiaryAfterFirstRecord,
      showTelegramBlock,
      showSettingInstruction,
      setSettingState,
      forceFill,
      availableSubscriptionTools,
      hasDiaryAccess,
    }
  },
}
</script>

<style scoped lang="scss">
.header_green {
  font-size: 24px;
  font-weight: bold;
  color: #51bb50;
}

.record_saved_wrapper {
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  text-align: justify;
}

.record_saved_header {
  font-size: 18px;
  font-weight: bold;
  color: #2cc185;
}

.setting_block_wrapper {
  padding: 20px 0;
  display: flex;
  column-gap: 10px;
  justify-content: space-between;
}

.settings {
  width: 40%;
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  margin-left: auto;
}

.show_settings_instruction_btn {
  margin-left: auto;
}

.settings_btn,
.show_settings_instruction_btn {
  cursor: pointer;
  border: 1px solid #000;
}

.settings_btn,
.show_settings_instruction_btn {
  text-transform: uppercase;
}

.settings_btn:hover,
.show_settings_instruction_btn:hover {
  background-color: #cccccc;
  text-transform: uppercase;
}

.settings_header {
  padding-left: 10px;
  margin-right: auto;
}

.settings_instruction {
  position: relative;
  width: 50%;
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 10px;
  border: 1px solid #2CC185;
}

.settings_instruction_header {
  color: #2cc185;
  font-weight: bold;
}

.settings_steps_list {
  padding-left: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.settings_steps_list li {
  list-style: decimal;
}

.settings_instruction_result {
  font-weight: bold;
}

.instruction_buttons_wrapper {
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
}

.description {
  color: #2cc185;
  font-size: 18px;
  font-weight: bold;
}

.info_wrapper {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.info_block_wrapper {
  display: flex;
  column-gap: 15px;
  align-items: center;
}

.info_text_wrapper {
  padding: 10px;
  background-color: #edf2f8;
}

.info_icon {
  width: 115px;
  height: 115px;
}

.analytics_wrapper,
.telegram_wrapper {
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 10px;
}

.analytics_text,
.bot_description {
  width: 60%;
}

.telegram_block {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.telegram_button {
  display: block;
  padding: 10px 20px;
  color: #ffffff;
  font-weight: bold;
  background-color: #3882ff;
}

.bot_description {
  font-style: italic;
}

.telegram_button:hover,
.telegram_btn:hover {
  background-color: #4a8efc;
}

.telegram_setting_button {
  margin-left: auto;
}

.telegram_btn {
  border-color: #3882ff;
  background-color: #3882ff;
}

.button_active {
  background-color: #eeeeee;
  color: #ccc;
  border-color: #d4d5d5;
}

.show_settings_instruction_btn.button_active {
  text-transform: capitalize;
}

.telegram_btn.button_active:hover,
.show_settings_instruction_btn.button_active:hover {
  color: #000;
  background-color: #ffffff;
  text-transform: capitalize;
}

.telegram_instruction_wrapper {
  position: relative;
  margin: 25px 0;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px;
  border: 1px solid #2cc185;
}

.telegram_instruction_header {
  color: #2cc185;
  font-weight: bold;
}

.telegram_instruction_list {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding-left: 25px;
}

.telegram_instruction_list li {
  list-style: initial;
}

.settings_instruction:before,
.telegram_instruction_wrapper:before {
  content: '';
  position: absolute;
  top: -12px;
  left: -20px;
  width: 40px;
  height: 40px;
  background-image: url('../../assets/images/icons/green_star.svg');
  background-repeat: no-repeat;
  background-size: contain;
}

.winking_face {
  position: relative;
}

.winking_face:before {
  content: '';
  top: 2px;
  left: 4px;
  position: absolute;
  width: 20px;
  height: 20px;
  background-image: url('../../assets/images/icons/winking_face.png');
  background-repeat: no-repeat;
  background-size: contain;
}

.arrow_wrapper {
  margin-top: 15px;
}

.additional_arrow_wrapper,
.record_now_line_wrapper {
  display: flex;
  align-items: center;
}

.arrow_line {
  width: 40px;
  height: 2px;
  background-color: #2cc185;
}

.arrow {
  width: 0;
  height: 0;
  border-bottom: 5px solid transparent;
  border-left: 6px solid #2cc185;
  border-top: 5px solid transparent;
}

.arrow_big {
  width: 0;
  height: 0;
  border-bottom: 10px solid transparent;
  border-left: 11px solid #2cc185;
  border-top: 10px solid transparent;
}

.records {
  margin-top: 80px;
}

.records_form_wrapper {
  margin-top: 50px;
  margin-bottom: 25px;
}

.records_control_wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.records_control_wrapper:has(.next_available_interval){
  justify-content: space-between;
}

.next_available_interval {
  width: 80%;
}

.record_now_text_wrapper {
  width: 100%;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  color: #2cc185;
  column-gap: 20px;
}

.record_now_text_wrapper .arrow_line {
  height: 3px;
  width: 100%;
}

.record_now_line_wrapper {
  width: 50%;
}

.info_img_wrapper {
  display: flex;
  margin: 15px 0;
}

.info_img {
  width: 49.4%;
}

.mobile {
  display: none;
}

.emotion_library_wrapper {
  display: flex;
  column-gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.diary_description {
  margin-top: 20px;
}

.diary_additional_header {
  font-size: 18px;
}

.diary_explanation_wrapper {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  text-align: justify;
}

.additional_library_link_wrapper {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.additional_library_button_wrapper {
  margin-top: 15px;
}

@media (max-width: 1170px) {
  .next_available_interval {
    width: 80%;
  }

  .record_now_line_wrapper {
    width: 45%;
  }

  .record_now_text_wrapper .arrow_line {
    width: 70%;
  }
}

@media (max-width: 1100px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }

  .record_now_line_wrapper {
    width: 25%;
  }
}

@media (max-width: 950px) {
  .record_now_line_wrapper {
    display: none;
  }

  .records_control_wrapper {
    column-gap: 5px;
  }
}

@media (max-width: 850px) {
  .setting_block_wrapper {
    flex-direction: column;
  }

  .settings_instruction {
    width: 100%;
  }

  .settings {
    width: 100%;
  }

  .arrow_wrapper {
    margin-top: 5px;
    width: 50%;
  }

  .additional_arrow_wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .additional_arrow_wrapper .arrow_line {
    width: 2px;
    height: 20px;
    background-color: #2cc185;
  }

  .additional_arrow_wrapper .arrow {
    width: 0;
    height: 0;
    border-right: 5px solid transparent;
    border-top: 6px solid #2cc185;
    border-left: 5px solid transparent;
  }
}

.change_intervals_text {
  margin-top: 10px;
}

@media (max-width: 500px) {
  .records_control_wrapper {
    justify-content: space-between;
    column-gap: 15px;
  }

  .records {
    margin-top: 50px;
  }

  .settings {
    position: relative;
  }

  .settings_header {
    margin-bottom: 15px;
  }

  .analytics_wrapper,
  .telegram_wrapper {
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    row-gap: 10px;
  }

  .bot_description,
  .analytics_text {
    width: 100%;
    text-align: justify;
  }

  .info_img_wrapper {
    flex-direction: column;
    row-gap: 10px;
    margin-bottom: 60px;
  }

  .info_img {
    width: 100%;
  }
}

@media(max-width: $tablet-breakpoint) {
  .card-body {
    padding: 0;
  }
}

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 0;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
}
</style>